var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "footer-location" }, [
    _c("div", { staticClass: "footer-location__title" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("footer_5")) + "\n  ")
    ]),
    _c("div", { staticClass: "footer-location__items" }, [
      _c("article", { staticClass: "footer-location__item" }, [
        _c("div", { staticClass: "footer-location__item__title" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("footer_6")) + "\n      ")
        ]),
        _c("time", { staticClass: "footer-location__item__content" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.getDate("America/New_York")) + "\n      "
          )
        ])
      ]),
      _c("article", { staticClass: "footer-location__item" }, [
        _c("div", { staticClass: "footer-location__item__title" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("footer_8")) + "\n      ")
        ]),
        _c("time", { staticClass: "footer-location__item__content" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.getDate("Europe/London")) + "\n      "
          )
        ])
      ]),
      _c("article", { staticClass: "footer-location__item" }, [
        _c("div", { staticClass: "footer-location__item__title" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("footer_9")) + "\n      ")
        ]),
        _c("time", { staticClass: "footer-location__item__content" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.getDate("Europe/London")) + "\n      "
          )
        ])
      ]),
      _c("article", { staticClass: "footer-location__item" }, [
        _c("div", { staticClass: "footer-location__item__title" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("footer_11")) + "\n      ")
        ]),
        _c("time", { staticClass: "footer-location__item__content" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.getDate("Europe/Copenhagen")) + "\n      "
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-975148c2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-975148c2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer-location-view.vue
// module id = 432
// module chunks = 56